<template>
  <div>
    <BlocoFiltroPesquisa
      nome-do-form="UsuariosBloqueioForm"
      :ordenar-nomes="['Nome', 'Email', 'Perfil', 'Motivo']"
      :ordenar-por="['user.name', 'user.email', 'user.perfil', 'motivo']"
      @pesquisar="pesquisar"
      @ordenar="ordenar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="form-group col-xs-12 col-sm-8 col-md-6 col-lg-6">
            <BuscarSelecionarUsuario
              @selecionadoUsuario="filtro.usuarioId = $event._id"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataInicio"
              label="Data Início"
              @atualizar="filtro.dataInicio = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarData
              id="dataFim"
              label="Data Fim"
              @atualizar="filtro.dataFim = $event"
            />
          </div>
          <div class="form-group col-xs-12 col-sm-8 col-md-4 col-lg-2">
            <SelecionarSituacao @atualizar="filtro.ativo = $event" />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela><BloqueioTabela :bloqueios="bloqueios" /></template>
      <template #fichas>
        <div
          v-for="bloqueio in bloqueios"
          :key="bloqueio._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <BloqueioFicha :bloqueio="bloqueio" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import BuscarSelecionarUsuario from '@/componentes/formulario/BuscarSelecionarUsuario'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import UsuarioBloqueioServico from '@/servicos/UsuarioBloqueioServico'
import appStore from '@/stores'

import BloqueioFicha from './BloqueioFicha'
import BloqueioTabela from './BloqueioTabela'

export default {
  components: {
    BloqueioFicha,
    BloqueioTabela,
    BlocoFiltroPesquisa,
    BuscarSelecionarUsuario,
    SelecionarData,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const servico = new UsuarioBloqueioServico()
    const nomeResultado = 'bloqueios'
    const bloqueios = ref([])
    const usuarios = ref([])
    const filtro = ref({
      dataInicio: '',
      dataFim: '',
      ativo: '',
      usuarioId: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: bloqueios,
      servico,
      nomeResultado,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(40)
    return { bloqueios, usuarios, filtro, ...pesquisa }
  },

  computed: {
    usuario() {
      return appStore.usuario
    },
  },
}
</script>
